"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.RichTextEditor = void 0;
var jsx_runtime_1 = require("react/jsx-runtime");
var react_1 = require("react");
var react_quill_1 = __importDefault(require("react-quill"));
require("react-quill/dist/quill.snow.css");
var formats = ["header", "bold", "italic", "underline", "strike", "blockquote", "list", "bullet", "indent", "link", "image", "color", "font", "size"];
var modules = {
    toolbar: [
        [{ header: [1, 2, 3, 4, 5, 6, false] }],
        ["bold", "italic", "underline", "strike", "blockquote"],
        [{ list: "ordered" }, { list: "bullet" }, { indent: "-1" }, { indent: "+1" }],
        ["link", "image"],
        ["clean"],
    ],
};
var RichTextEditor = function (_a) {
    var onTextChange = _a.onTextChange, initialContent = _a.initialContent;
    var _b = (0, react_1.useState)(""), text = _b[0], setText = _b[1];
    (0, react_1.useEffect)(function () {
        setText(initialContent);
    }, [initialContent]);
    var handleChange = function (value) {
        setText(value);
        onTextChange(value);
    };
    return ((0, jsx_runtime_1.jsxs)("div", __assign({ className: "editor-wrapper border-0 bg-gray-100 rounded-xl" }, { children: [(0, jsx_runtime_1.jsx)(react_quill_1.default, { value: text, onChange: handleChange, formats: formats, modules: modules, className: "rounded-xl" }), (0, jsx_runtime_1.jsx)("style", { children: "\n          .editor-wrapper .quill {\n            border-radius: 0.75rem;\n            border: none;\n          }\n          \n          .editor-wrapper .ql-toolbar.ql-snow {\n            border: none;\n            border-bottom: none;\n            padding: 8px;\n            border-radius: 0.75rem 0.75rem 0 0;\n          }\n          \n          .editor-wrapper .ql-container.ql-snow {\n            border: none;\n            border-radius: 0 0 0.75rem 0.75rem;\n          }\n          \n          .editor-wrapper .ql-editor {\n            font-family: var(--nextui-fonts-sans);\n            font-size: 0.875rem;\n          }\n        " })] })));
};
exports.RichTextEditor = RichTextEditor;
